import React from "react";

const STEPS = [
  {
    n: "01",
    title: "Pilih Kategori",
    text: "Tentukan jenis kebutuhan hukum dari daftar layanan yang tersedia.",
  },
  {
    n: "02",
    title: "Buka Kontak",
    text: "Gunakan nomor telepon, WhatsApp, atau email resmi yang tampil di bagian kontak.",
  },
  {
    n: "03",
    title: "Kirim Dokumen Awal",
    text: "Sampaikan kebutuhan dan dokumen awal yang ingin diperiksa.",
  },
  {
    n: "04",
    title: "Janji Temu",
    text: "Tim kantor akan mengatur waktu konsultasi lanjutan yang sesuai.",
  },
];

export const Process = () => {
  return (
    <section
      id="proses"
      data-testid="process-section"
      className="py-24 lg:py-32 bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="hp-divider" />
              <span className="overline">Proses</span>
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl font-light tracking-tight leading-[1.05] text-[#1A2B29]">
              Alur konsultasi yang <em className="italic text-[#C4A661]">langsung dan jelas</em>.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pl-12 lg:border-l border-[#E5E3DC]">
            <p className="text-base text-[#5C6B69] leading-relaxed">
              Informasi layanan ditampilkan ringkas supaya kebutuhan awal dapat langsung
              disampaikan ke kantor melalui kanal resmi.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E3DC] border border-[#E5E3DC]">
          {STEPS.map((s, i) => (
            <div
              key={i}
              data-testid={`process-step-${i + 1}`}
              className="bg-[#F9F8F6] p-8 lg:p-10 hover:bg-white transition-colors"
            >
              <div className="font-serif italic text-5xl text-[#C4A661] mb-7">{s.n}</div>
              <h3 className="font-serif text-xl text-[#1A2B29] mb-3 tracking-tight">{s.title}</h3>
              <p className="text-sm text-[#5C6B69] leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
